import React from 'react';
import {useSelector} from 'react-redux';
import {noop} from 'lodash';

import {NewLabelCandidate} from '/component/base/NewLabelCandidate';
import {generateOnRecordPress} from '/component/partial/PeopleToContact/PeopleToContact.util';
import {PeopleToContactDataProvider} from '/component/partial/PeopleToContact/PeopleToContactDataProvider';
import AcceptByComponent from '/component/partial/report/AcceptByComponent';
import CandidateDateAdded from '/component/partial/report/CandidateDateAdded/CandidateDateAdded';
import {CandidateReportAcceptByIconComponent} from '/component/partial/report/CandidateReportAcceptByIconComponent/CandidateReportAcceptByIconComponent';
import CandidateSource from '/component/partial/report/CandidateSource/CandidateSource';
import PersonFullName from '/component/partial/report/PersonFullName';
import {NEW_CANDIDATE} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface NewCandidateProps {
  onItemPress: (item: any) => void;
  onShowProfile: () => void;
  parentScreenName: string;
  showFullReport: boolean;
  reportParams: any;
}

export const NewCandidate: React.FC<NewCandidateProps> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
  });

  const {ff_accept_decline = ''} = useSelector(variablesFeatureFlag);

  const onViewMore = () => {
    onItemPress({
      value: 0,
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;

  return (
    <PeopleToContactDataProvider
      screenParams={{type: NEW_CANDIDATE}}
      clientMilestone={FILTER_TYPES.candidate}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE}
      parentScreenName={parentScreenName}
      isCandidateReport
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: CandidateDateAdded,
        personInfoComponent: CandidateSource,
        NewLabelComponent: NewLabelCandidate,
        AcceptByIconComponent:
          shouldReleaseFeature(ff_accept_decline) &&
          CandidateReportAcceptByIconComponent,
        AcceptByComponent:
          shouldReleaseFeature(ff_accept_decline) && AcceptByComponent,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
